import { createContext, ReactNode } from "react";

import { FieldValues, useForm } from "react-hook-form";

export interface FormData extends FieldValues {
  selectedCustomer: string;
  quoteOption: string;
  selectedQuote?: string;
}

export interface QuoteAssociationContextType {
  handleSubmit: (callback: (data: FormData) => void) => (e?: React.BaseSyntheticEvent) => Promise<void>;
  watch: (name?: string | string[]) => any;
  setValue: (name: string, value: any) => void;
  quoteOption: string;
  selectedCustomer: string;
  selectedQuote: string | undefined;
}

export const QuoteAssociationContext = createContext<QuoteAssociationContextType | undefined>(undefined);

interface QuoteAssociationProviderProps {
  children: ReactNode;
}

export const QuoteAssociationProvider = ({ children }: QuoteAssociationProviderProps) => {
  const {
    handleSubmit: handleSubmitForm,
    watch,
    setValue,
  } = useForm<FormData>({
    defaultValues: {
      selectedCustomer: "",
      quoteOption: "existing",
      selectedQuote: "",
    },
  });

  const quoteOption = watch("quoteOption");
  const selectedCustomer = watch("selectedCustomer");
  const selectedQuote = watch("selectedQuote");

  const value: QuoteAssociationContextType = {
    handleSubmit: handleSubmitForm,
    watch,
    setValue,
    quoteOption,
    selectedCustomer,
    selectedQuote,
  };

  return (
    <QuoteAssociationContext.Provider value={value}>
      {children}
    </QuoteAssociationContext.Provider>
  );
};
